/*jshint scripturl:true*/
var maxScrollDepth = 0,
    scrollDepthSent = false;

$(document)
    .ready(function() {

        if ($('body').data('scrollDepth')) {
            $.scrollDepth({
                pixelDepth: false,
                userTiming: false,
                eventHandler: function(data) {
                    var scrollDepth = parseInt(data.eventLabel); // z.B. 25, 50, 75, 100
                    if (scrollDepth > maxScrollDepth) {
                        maxScrollDepth = scrollDepth;
                    }
                    trackEvent(data.eventCategory, data.eventAction, data.eventLabel, data.eventValue, data.eventNonInteraction, "matomo");
                }
            });
        }


        setTimeout(function() {
            var waAnalysis = {
                _tracking: false,
                _consent: {
                    mode: (advancedConsentMode) ? 'advanced' : 'simple',
                    values: (typeof consentObj != "undefined") ? consentObj : false
                },
                tools: []
            };
            // if ($.cookie('cookieConsented-analysis') == '1') {
            // waAnalysis._tracking = true;
            if ($('#google_analyticsJS').length) {
                waAnalysis._tracking = true;
                waAnalysis.tools.push({
                    'analyticsJS': ($('#gaCode').data('code') === '{$googleAnalyticsAccount}') ? 'extern (gtm, etc.)' : $('#gaCode').data('code')
                });
            }
            if ($('#google_gtag').length) {
                waAnalysis._tracking = true;
                waAnalysis.tools.push({
                    'gtag': ($('#gaCode').data('code') === '{$googleAnalyticsAccount}') ? 'extern (gtm, etc.)' : $('#gaCode').data('code')
                });
            }
            // }
            if ($('#matomoTracking').length) {
                waAnalysis._tracking = true;
                waAnalysis.tools.push({
                    'Matomo': $('#matomoTracking').data('id')
                });
            }
            if (waAnalysis._tracking) {
                console.table("%c TTG Debug ", "background: #0080a3; color: #fff", waAnalysis);
            }

            // PUSH WOODSTOCK GS AUFRUF // OMNICHANNEL-65
            if ($('body').data('pid') == '49948') {
                push2insider({
                    type: 'custom_event',
                    value: [{
                        event_name: 'gewinnspiel_page_visit',
                        event_parameters: {
                            custom: {
                                gewinnspiel: 'woodstock_2026'
                            }
                        }
                    }]
                });
            }
        }, 500);

        // #mailto Anker in URL > Fancy Form Init opened < sofern vorhanden
        if (window.location.hash === '#mailto') {

            // Selektoren
            var $mailLink = $('[data-eventaction="Kontaktblock Mail"]').first();
            var $wrapper = $('.ttgFancyAnfrageWrapper');

            // Bedingungen prüfen
            if ($mailLink.length && $wrapper.length) {
                // Etwas warten, falls andere JS-Initialisierungen laufen
                setTimeout(function() {
                    $mailLink.trigger('click');
                }, 300);
            }
        }

    })
    .on('submit', '.ttgNewsKategorieFilterForm', function(e) {

        trackEvent('Redaktionelle Artikel / Liste', 'Filterung der Liste', '');

    })
    .on("click", "#ttgNCEHeaderSlider .right.carousel-control", function(e) {

        trackEvent('Global', 'Header Slider', 'Vor');

    })
    .on("click", "#ttgNCEHeaderSlider .left.carousel-control", function(e) {

        trackEvent('Global', 'Header Slider', 'Zurück');

    })
    .on("click", ".ttgVcard .ttgTrackShowPhone", function(e) {

        e.preventDefault();
        $('.ttgTelNrPartial').removeClass('ttgTelNrPartial').addClass('ttgTelNrPartialInactive');
        $('.ttgVcard .ttgTrackShowPhone').remove();
        trackEvent('Tourdata Events', 'Telefonnummer Link', 'viewed');

    })
    .on('click', 'a:not([data-eventCategory])', function(e) {

        // Nur ausführen, wenn Google Analytics aktiv ist
        if ($('.ttgDataWrapperOnlyNeededForJS').attr('data-googleanalyticsactive') == 1) {

            // Telefonnummern
            var href = $(this).attr('href');

            if (href.match("^tel:") && !$(this).hasClass('ttgNewsTelefonLink')) {

                trackEvent('Global', 'Kontaktblock Telefon', 'clicked');

            } else {

                // Nur ausführen, wenn es NICHT um eine TOURDATA-Detailseite handelt
                if ($('.ttgTourdataDetailSeite').length == 0) {

                    // REDAKTIONELLE ARTIKEL
                    // Liste
                    if ($(this).hasClass('ttgNewsListLink')) {
                        var artikelID = $(this).parent().attr('data-id');
                        var artikelTitle = $(this).parent().attr('data-titel');
                        trackEvent('Redaktionelle Artikel / Liste', 'Öffnen eines Artikels', artikelID + ' / ' + artikelTitle);
                    }

                    // Liste / Detailseite: E-Mail Adresse
                    if ($(this).hasClass('ttgNewsMailLink')) {
                        trackEvent('Redaktionelle Artikel / Kontaktblock', 'Klick auf E-Mail Adresse', href);
                    }

                    // Liste / Detailseite: Telefon
                    if ($(this).hasClass('ttgNewsTelefonLink')) {
                        trackEvent('Redaktionelle Artikel / Kontaktblock', 'Klick auf Telefonnummer', href);
                    }

                    /* Tracking ext. Links entfernt > OOEAT-5182
                    // Liste / Detailseite: Website
                    if ($(this).hasClass('ttgNewsWebLink')) {
                        trackEvent('Redaktionelle Artikel / Kontaktblock', 'Klick auf Website', href);
                    }
                    */

                    /* Tracking Download entfernt > OOEAT-5182
                    // Detailseite: Dokumente
                    if ($(this).hasClass('ttgNewsFiles')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Datei-Download', href);
                    }
                    */

                    // Detailseite: In Verbindung stehende Artikel
                    if ($(this).hasClass('ttgNewsVerwandteArtikel')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf in Verbindung stehenden Artikel', href);
                    }

                    // Detailseite: Weiterführende Links
                    if ($(this).parents().hasClass('ttgNewsWeiterfuehrendeLinks')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf weiterführenden Link', href);
                    }

                    // Detailseite: TOURPIX
                    if ($(this).hasClass('ttgNewsTourpixDownload')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf TOURPIX-Relation', href);
                    }

                    // Detailseite: Detaillierte Karte
                    if ($(this).hasClass('ttgNewsDetailKarte')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf detaillierte Karte', '');
                    }

                    // Mailto-Link
                    if (href.match("^anfrage")) {
                        var mailtoValue = $(this).text();
                        trackEvent('Global', 'Kontaktblock Mail', mailtoValue);
                    } // if

                    /* Tracking ext. Links entfernt > OOEAT-5182
                    // PDF-Download
                    var isPDF = $(this).attr('href').search('.pdf');

                    if (isPDF != "-1") {
                        trackEvent('Global', 'PDF Download', $(this).attr('href'));
                    } // if
                    */

                    // Social Share NCE
                    if ($(this).hasClass('ttgSocialShareLink')) {
                        trackEvent('Global', 'Social Sharing', 'Facebook NCE');
                    }

                    /* Tracking ext. Links entfernt > OOEAT-5182
                    // javascript:void(0)
                    // var isVoid = $(this).attr('href').search('javascript');

                    // if (isVoid == "-1") {

                    //     // Externe links
                    //     var getLocation = function(href) {
                    //         var l = document.createElement("a");
                    //         l.href = href;
                    //         return l;
                    //     };

                    //     var l = getLocation($(this).attr('href'));
                    //     var linkDomain = getHostname(l);

                    //     var baseURL = window.location.protocol + "//" + window.location.host;

                    //     if (baseURL != linkDomain) {

                    //         if ($(this).attr('href') != "javascript:void(0)") {
                    //             trackEvent('Global', 'Externer Link', $(this).attr('href'));
                    //         } // if

                    //     } // if

                    // } // if - javascript:void(0)
                    */

                } // if - TOURDATA-Detailseite

            } // if - Telefonnummer

        } // if - Google Analytics

    })
    .on('click', '[data-eventcategory]', function(e) {

        var trackerObj = $(this);
        if (trackerObj.data('eventcategory') && trackerObj.data('eventaction') && trackerObj.data('eventlabel')) {
            // context = umschließendes <form> des geklickten Buttons; wird für Insider-buildUserData()/buildEventParams()
            // benötigt, falls das Formular eine dynamische ID hat und mehrfach pro Seite vorkommen kann (z. B. Anfrage-Modals)
            trackEvent(trackerObj.data('eventcategory'), trackerObj.data('eventaction'), trackerObj.data('eventlabel'), undefined, undefined, undefined, undefined, trackerObj.closest('form'));
        } else {
            if (!trackerObj.data('eventcategory')) {
                console.log('eventCategory has to be defined');
            }
            if (!trackerObj.data('eventaction')) {
                console.log('eventAction has to be defined');
            }
            if (!trackerObj.data('eventlabel')) {
                console.log('eventLabel has to be defined');
            }
        }

        // data-removeElement für Elemente, welche nach dem Klick entfernt werden sollen
        if (trackerObj.data('removeelement') == 1) {
            trackerObj.remove();
        }

    })

    .on('click', '.ttg-carousel-item a', function(e) {
        trackEvent('Global', 'NCE-Karussell', $(this).attr('href'));
    })

    // Formular Events
    .on("submit", "#ttgKatalogForm", function(e) {

        var kataloge = function() {

            var kat = '';
            $.each($('#ttgKatalogForm .ttgAuswahl .checkedCat'), function(k, v) {
                kat += (kat !== '') ? ', ' + $(this).data('catid') : $(this).data('catid');
            });
            return kat;

        };

        if ($('#ttgKatalogForm .ttgWanderkarteBestellenButton').length > 0) {
            // trackEvent('Formular', 'Wanderkarte bestellt', kataloge()); /* funkt. direkt über Button */
        } else {
            trackEvent('Formular', 'Prospekt bestellt', kataloge());
        }

    })
    // .on("submit", ".ttgWanderkarteBestellenButton", function(e) {

    //     trackEvent('Formular', 'Wanderkarte bestellt', $('#kataloge').val());

    // })

    // quickIcons
    .on('click', ".quickIconsHolder a, .quickIconsHolder #ttgQuickNaviMap > span", function(e) {

        trackEvent('Global', 'Quicklinks', $(this).find('.infotext').text());

    });

function getHostname(url) {

    url = url.toString();
    var m = url.match(/^http.?:\/\/[^/]+/);
    return m ? m[0] : null;

}

/* ==================================================================================
   INSIDER TRACKING KONFIGURATION
   - Generischer Mechanismus (analog zu Google/Matomo in trackEvent()), ABER im
     Gegensatz zu Google/Matomo mit Whitelist-Prinzip: nur Events, die hier explizit
     über eine Regel definiert sind, werden an Insider gepusht.
   - Neues Event für Insider freischalten: Regel unten ergänzen,
     KEINE Änderung an den jeweiligen trackEvent()-Aufrufstellen nötig.
   ================================================================================== */

// Entfernt Keys mit leerem Wert, statt Datenmüll an Insider zu senden
function stripEmptyValues(obj) {
    var result = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== '' && obj[key] !== null && typeof obj[key] !== 'undefined') {
            result[key] = obj[key];
        }
    }
    return result;
}

// Entfernt nur Satzzeichen/Leerzeichen am Anfang & Ende (z. B. Rufzeichen im Gewinnspieltitel); keine Normalisierung wie Kleinschreibung
// À-ſ statt \p{L}\p{N} (Unicode Property Escapes), da JSHint 2.10.3 diese nicht parsen kann; deckt Umlaute/Latin-Extended-A ab
function trimPunctuation(str) {
    return (str || '').toString().replace(/^[^A-Za-z0-9À-ſ]+|[^A-Za-z0-9À-ſ]+$/g, '');
}

// Prüft einen einzelnen Regel-Wert (Array = einer der Werte exakt, RegExp = .test(), String = exakter Vergleich) gegen den tatsächlichen trackEvent()-Wert
function insiderFieldMatches(matcher, val) {
    if (Array.isArray(matcher)) {
        return matcher.includes(val);
    }
    return (matcher instanceof RegExp) ? matcher.test(val) : (matcher === val);
}

// Fallback für insiderEventName, falls in der Regel nicht explizit gesetzt: eventAction kleingeschrieben, Sonderzeichen -> '_'
function slugifyInsiderEventName(str) {
    return (str || '')
        .toString()
        .toLowerCase()
        .replace(/[^A-Za-z0-9À-ſ]+/g, '_')
        .replace(/^_+|_+$/g, '');
}

// Prüft, ob eine Insider-Regel auf den aktuellen trackEvent()-Aufruf zutrifft
function insiderRuleMatches(rule, eventCategory, eventAction, eventLabel, value) {
    if (typeof rule.match === 'function') {
        return !!rule.match(eventCategory, eventAction, eventLabel, value);
    }
    if (rule.eventCategory !== undefined && !insiderFieldMatches(rule.eventCategory, eventCategory)) return false;
    if (rule.eventAction !== undefined && !insiderFieldMatches(rule.eventAction, eventAction)) return false;
    if (rule.eventLabel !== undefined && !insiderFieldMatches(rule.eventLabel, eventLabel)) return false;
    return true;
}

/* ==================================================================================
   GEMEINSAME HELPER für Insider-User-Profile (Formularfeld -> Insider-Attribut)
   ================================================================================== */

// Anrede: 'Herr' -> 'M', 'Frau' -> 'F'; sonst weglassen statt Datenmüll zu senden
function mapAnredeToGender(anredeRaw) {
    var val = (anredeRaw || '').toLowerCase();
    return val.includes('herr') ? 'M' : (val.includes('frau') ? 'F' : '');
}

// Land: Freitextfeld -> ISO-3166 alpha-2 (Insider erwartet z. B. 'AT'); unbekannte Werte werden weggelassen statt Datenmüll zu senden
var COUNTRY_NAME_TO_ISO = [
    { contains: 'österreich', code: 'AT' },
    { contains: 'austria', code: 'AT' },
    { contains: 'deutschland', code: 'DE' },
    { contains: 'germany', code: 'DE' },
    { contains: 'schweiz', code: 'CH' },
    { contains: 'switzerland', code: 'CH' },
    { contains: 'suisse', code: 'CH' },
    { contains: 'svizzera', code: 'CH' },
    { contains: 'italien', code: 'IT' },
    { contains: 'italy', code: 'IT' },
    { contains: 'italia', code: 'IT' }
];

function mapCountryNameToIso(countryRaw) {
    var val = (countryRaw || '').trim().toLowerCase();
    for (var i = 0; i < COUNTRY_NAME_TO_ISO.length; i++) {
        if (val.includes(COUNTRY_NAME_TO_ISO[i].contains)) {
            return COUNTRY_NAME_TO_ISO[i].code;
        }
    }
    return '';
}

// Telefon: Freitextfeld -> E.164 normalisieren (Insider erwartet z. B. '+4366012345678'); Zielgruppe = Österreich
function normalizePhoneNumberAT(phoneRaw) {
    var phoneDigits = (phoneRaw || '').replace(/[^\d+]/g, '');

    if (phoneDigits.indexOf('00') === 0) {
        phoneDigits = '+' + phoneDigits.slice(2); // internationale Vorwahl '00' -> '+'
    } else if (phoneDigits.indexOf('+') !== 0) {
        if (phoneDigits.indexOf('0') === 0) {
            phoneDigits = '+43' + phoneDigits.slice(1); // Inlandsnummer mit führender 0 (z. B. '0660...')
        } else if (phoneDigits.indexOf('43') === 0 && phoneDigits.length >= 8) {
            phoneDigits = '+' + phoneDigits; // Landesvorwahl ohne '+' angegeben (z. B. '43660...')
        } else if (phoneDigits.length > 0) {
            phoneDigits = '+43' + phoneDigits; // keine Vorwahl erkennbar -> als österreichische Nummer annehmen
        }
    }

    // E.164: '+' gefolgt von 7-15 Ziffern (erste Ziffer nicht 0); sonst Feld weglassen statt Datenmüll zu senden
    return /^\+[1-9]\d{6,14}$/.test(phoneDigits) ? phoneDigits : '';
}

/* Gewinnspiel-Teilnahme: Anrede, Geburtsdatum, Land, Telefon etc. aus dem Formular
   in ein Insider-User-Profil umwandeln (OCC-33, generisch für jedes Gewinnspiel) */
function buildGewinnspielUserData() {

    // Geburtsdatum: 'TT.MM.JJJJ' -> ISO-8601 Datetime konvertieren (Insider erwartet z. B. '2000-01-20T00:00:00Z')
    var birthdayRaw = ($('#ttgGewinnspielDaten [name="geburtsdatum"]').val() || '');
    var birthdayParts = birthdayRaw.split('.');
    var birthday = (birthdayParts.length === 3) ? (birthdayParts[2] + '-' + birthdayParts[1] + '-' + birthdayParts[0] + 'T00:00:00Z') : '';

    var customValue = stripEmptyValues({
        titel: ($('#ttgGewinnspielDaten [name="titel"]').val() || ''),          // Titel
        strasse: ($('#ttgGewinnspielDaten [name="strasse"]').val() || ''),      // Straße / Nr.
        plz: ($('#ttgGewinnspielDaten [name="plz"]').val() || '')               // PLZ
    });

    var userValue = stripEmptyValues({
        gender: mapAnredeToGender($('#ttgGewinnspielDaten [name="anrede"]').val()),   // Anrede (umgewandelt in M/F)
        name: ($('#ttgGewinnspielDaten [name="vorname"]').val() || ''),             // Vorname
        surname: ($('#ttgGewinnspielDaten [name="nachname"]').val() || ''),         // Nachname
        email: ($('#ttgGewinnspielDaten [name="adress"]').val() || ''),             // E-Mail (Pflichtfeld)
        phone_number: normalizePhoneNumberAT($('#ttgGewinnspielDaten [name="telefon"]').val()), // Telefon (E.164, sofern erkannt)
        birthday: birthday,                                                         // Geburtsdatum (ISO-8601)
        city: ($('#ttgGewinnspielDaten [name="city"]').val() || ''),                // Ort
        country: mapCountryNameToIso($('#ttgGewinnspielDaten [name="land"]').val()), // Land (ISO-3166 alpha-2, sofern erkannt)
        language: 'de',
        gdpr_optin: true    // = Zustimmung Teilnahmebedingungen (Pflicht-Checkbox > daher immer true)
    });

    if (Object.keys(customValue).length > 0) {
        userValue.custom = customValue;
    }

    return userValue;
}

/* Anfrage-Formulare (ttg_anfragen: Pauschale/Unterkunft, Fancy, Location, Footer, Feedback) -> Insider-User-Profil.
   Diese Formulare haben eine dynamische ID (ttgAnfrageForm{uid}) und können mehrfach pro Seite vorkommen
   (z. B. mehrere Anfrage-Modals) - deshalb wird über `context` (das konkret abgeschickte <form>, siehe
   trackEvent()-Aufruf im generischen [data-eventcategory]-Klick-Handler) gescoped statt über einen globalen Selektor.
   Nicht vorhandene Felder (z. B. kein Telefon im Feedback-Formular) werden von stripEmptyValues() automatisch entfernt. */
function buildAnfrageUserData(eventCategory, eventAction, eventLabel, value, context) {
    var $scope = (context && context.length) ? $(context) : $(document);

    var customValue = stripEmptyValues({
        titel: ($scope.find('[name="titel"]').val() || ''),      // Titel
        strasse: ($scope.find('[name="strasse"]').val() || ''),  // Straße / Nr.
        plz: ($scope.find('[name="plz"]').val() || '')           // PLZ
    });

    var userValue = stripEmptyValues({
        gender: mapAnredeToGender($scope.find('[name="anrede"]').val()),          // Anrede (umgewandelt in M/F), sofern im Formular vorhanden
        name: ($scope.find('[name="vorname"]').val() || ''),                      // Vorname
        surname: ($scope.find('[name="nachname"]').val() || ''),                  // Nachname
        email: ($scope.find('[name="email"]').val() || ''),                       // E-Mail (Pflichtfeld)
        phone_number: normalizePhoneNumberAT($scope.find('[name="telefon"]').val()), // Telefon (E.164, sofern vorhanden/erkannt)
        city: ($scope.find('[name="ort"]').val() || ''),                          // Ort
        country: mapCountryNameToIso($scope.find('[name="land"]').val()),         // Land (ISO-3166 alpha-2, sofern erkannt)
        language: 'de'
    });

    if (Object.keys(customValue).length > 0) {
        userValue.custom = customValue;
    }

    return userValue;
}

/* Katalog-/Wanderkarten-Bestellformular (#ttgKatalogForm, seitenweit eindeutig) -> Insider-User-Profil.
   Land ist hier bereits als ISO-3166-alpha-2-Select hinterlegt (kein Freitext wie bei Gewinnspiel/Anfrage),
   daher keine Namens-Zuordnung nötig, nur Format-Validierung. Geburtsdatum wird bewusst NICHT übernommen -
   das Feld ist dort ein ungebundenes Freitextfeld ohne festes Format, ein Parse-Versuch würde zu unzuverlässig. */
function buildKatalogUserData() {
    var $scope = $('#ttgKatalogForm');

    var customValue = stripEmptyValues({
        titel: ($scope.find('[name="titel"]').val() || ''),      // Titel
        strasse: ($scope.find('[name="strasse"]').val() || ''),  // Straße / Nr.
        plz: ($scope.find('[name="plz"]').val() || '')           // PLZ
    });

    var countryVal = ($scope.find('[name="land"]').val() || '').trim().toUpperCase();

    var userValue = stripEmptyValues({
        gender: mapAnredeToGender($scope.find('[name="anrede"]').val()),          // Anrede (umgewandelt in M/F)
        name: ($scope.find('[name="vorname"]').val() || ''),                      // Vorname
        surname: ($scope.find('[name="nachname"]').val() || ''),                  // Nachname
        email: ($scope.find('[name="email"]').val() || ''),                       // E-Mail
        phone_number: normalizePhoneNumberAT($scope.find('[name="telefon"]').val()), // Telefon (nur im Katalog-, nicht im Wanderkarten-Formular vorhanden)
        city: ($scope.find('[name="ort"]').val() || ''),                          // Ort
        country: /^[A-Z]{2}$/.test(countryVal) ? countryVal : '',                 // Land (bereits ISO-3166 alpha-2 im Select)
        language: 'de'
    });

    if (Object.keys(customValue).length > 0) {
        userValue.custom = customValue;
    }

    return userValue;
}

/* Gewinnspiel-Teilnahme: Titel + evtl. konfigurierte Zusatzfrage(n) als Insider Custom-Event-Params (generisch für jedes Gewinnspiel) */
function buildGewinnspielTeilnahmeParams() {

    // antwort1-3: geschlossene Fragen (Radio, je nach Gewinnspiel-Konfiguration 0-3 Stück vorhanden); offeneFrage: Freitext-Variante statt geschlossener Fragetyp
    return stripEmptyValues({
        gewinnspiel: trimPunctuation($('#ttgGewinnspielDaten [name="gewinnspieltitel"]').val()),      // Titel des Gewinnspiels (Plugin-Konfiguration)
        antwort1: trimPunctuation($('#ttgGewinnspielDaten [name="antwort1"]:checked').val()),         // Antwort auf Frage 1, sofern konfiguriert
        antwort2: trimPunctuation($('#ttgGewinnspielDaten [name="antwort2"]:checked').val()),         // Antwort auf Frage 2, sofern konfiguriert
        antwort3: trimPunctuation($('#ttgGewinnspielDaten [name="antwort3"]:checked').val()),         // Antwort auf Frage 3, sofern konfiguriert
        offene_frage: trimPunctuation($('#ttgGewinnspielDaten [name="offeneFrage"]').val())           // Freitext-Antwort (offener statt geschlossener Fragetyp)
    });
}

/* Regeln, welche trackEvent()-Aufrufe an Insider weitergepusht werden sollen.
   Matching über eventCategory/eventAction/eventLabel - dieselben Namen wie die
   trackEvent(eventCategory, eventAction, eventLabel, ...)-Parameter, gegen die gematcht wird
   (String = exakter Vergleich, Array = einer der Werte exakt, RegExp = .test()), oder eigene
   match(eventCategory, eventAction, eventLabel, value)-Funktion für komplexere Bedingungen.
   insiderEventName: Name, unter dem das Event bei Insider als custom_event ankommt - optional,
   ohne Angabe wird er automatisch abgeleitet: eventAction -> eventLabel -> eventCategory
   (kleingeschrieben, Sonderzeichen -> '_'; erstes nicht-leeres Feld gewinnt).
   pushUserData: true löst zusätzlich einen 'user'+'init'-Push aus (Insider-Profil) -
   z. B. nötig, wenn im selben Zug wie das Event auch Kontaktdaten übermittelt werden sollen.
   buildUserData(eventCategory, eventAction, eventLabel, value, context) und
   buildEventParams(eventCategory, eventAction, eventLabel, value, context) bekommen als 5. Argument
   `context` mit - das vom trackEvent()-Aufrufer übergebene DOM-/jQuery-Element (i. d. R. das abgeschickte
   <form>), zum Scopen der Feld-Selektoren, falls dasselbe Formular mehrfach pro Seite vorkommen kann. */
var insiderTrackingRules = [
    {
        // OCC-33
        // insiderEventName explizit gesetzt, da 'gewinnspiel_teilnahme' bereits als Event in Insider konfiguriert ist (weicht bewusst vom automatischen Slug 'gewinnspiel_teilgenommen' ab)
        eventAction: 'Gewinnspiel teilgenommen',
        insiderEventName: 'gewinnspiel_teilnahme',
        pushUserData: true,
        buildUserData: buildGewinnspielUserData,
        buildEventParams: buildGewinnspielTeilnahmeParams
    },
    {
        // OCC-33
        eventAction: 'Prospekt bestellt',
        insiderEventName: 'bestellung',
        pushUserData: true,
        buildUserData: buildKatalogUserData
    },
    {
        // OCC-33
        eventAction: 'Wanderkarte bestellt',
        insiderEventName: 'bestellung',
        pushUserData: true,
        buildUserData: buildKatalogUserData
    },
    {
        // OCC-33
        eventAction: 'Fancy Anfrage abgesendet',
        insiderEventName: 'formular',
        pushUserData: true,
        buildUserData: buildAnfrageUserData
    },
    {
        // OCC-33
        eventAction: 'Anfrage bei Pauschale gesendet',
        insiderEventName: 'formular',
        pushUserData: true,
        buildUserData: buildAnfrageUserData
    },
    {
        // OCC-33
        eventAction: 'Anfrage bei Unterkunft gesendet',
        insiderEventName: 'formular',
        pushUserData: true,
        buildUserData: buildAnfrageUserData
    },
    {
        // OCC-33
        eventAction: 'Footerformular Anfrage abgesendet',
        insiderEventName: 'formular',
        pushUserData: true,
        buildUserData: buildAnfrageUserData
    },
    {
        // OCC-33
        eventAction: 'Feedbackformular Anfrage abgesendet',
        insiderEventName: 'formular',
        pushUserData: true,
        buildUserData: buildAnfrageUserData
    },
    {
        // OCC-33: Content-Interesse (Tourdata-Objekt/News/Magazin-Kategorien) - siehe pushDataLayer()
        eventCategory: 'Interesse',
        insiderEventName: 'interesse'
    },
    {
        // OCC-33
        eventCategory: 'Engagement',
        insiderEventName: 'engagement'
    },
    {
        // OCC-33
        eventCategory: 'Tourdata Events',
        insiderEventName: 'tourdata_events'
    },
    {
        // OCC-33
        eventAction: 'Merkzettel'
    },
    {
        // OCC-33
        eventCategory: 'Unterkunftssuche Buchenbox',
        insiderEventName: 'unterkunftssuche_buchenbox'
    },
    {
        // OCC-33: deckt alle Varianten ab, z. B. 'TOURDATA Liste (Event)', 'TOURDATA Liste (Gastro)', 'TOURDATA Liste (Pauschale)' -
        // der Typ-Suffix ist dynamisch (16+ Listen-Templates), daher RegExp-Präfixmatch statt fixer Werte-Liste
        eventCategory: /^TOURDATA Liste \(/,
        insiderEventName: 'tourdata_liste'
    }
    // Weitere Events für Insider freischalten, z. B.:
    // { eventCategory: 'Formular', eventAction: 'Prospekt bestellt' } // insiderEventName weggelassen -> automatisch 'prospekt_bestellt'
];

function trackEvent(eventCategory, eventAction, eventLabel, value, nonInteraction, pushOnly, transport, context) {
    // context (optional): DOM-/jQuery-Element zur Scope-Eingrenzung für Insider-buildUserData()/buildEventParams(),
    // z. B. das konkret abgeschickte <form>, falls mehrere gleichartige Formulare auf der Seite vorkommen können

    var dontTrack = {
        categories: [],
        actions: [
            'Externer Link', // Global
            'PDF Download', // Global || Katalogbestellung
            'Datei-Download', // Global
            'Outgoing Weblink', // Tourdata Events
            'Klick auf Website', // Redaktionelle Artikel / Kontaktblock
            // 'Angebot Buchen Link' // Tourdata Events
        ],
        labels: [],
        values: []
    };

    if (
        !dontTrack.categories.includes(eventCategory) &&
        !dontTrack.actions.includes(eventAction) &&
        !dontTrack.labels.includes(eventLabel) &&
        !dontTrack.values.includes(value)
    ) {
        var tracking = {
            _enable: false,
            _consent: {
                mode: (advancedConsentMode) ? 'advanced' : 'simple',
                values: (typeof consentObj != "undefined") ? consentObj : false
            },
            _f: 'trackEvent()',
            _tools: [],
            category: eventCategory,
            action: eventAction,
            label: eventLabel,
            value: (value === undefined) ? false : value,
            nonInteraction: (nonInteraction === undefined) ? false : nonInteraction
        };

        // if ($.cookie('cookieConsented-analysis') == '1') {
        tracking._enable = true;

        if (!pushOnly || pushOnly === "google") {
            if ($('#google_analyticsJS').length) { // EventTracking mit Analytics JS [old]

                tracking._tools.push('analyticsJS');
                try {
                    ga('send', 'event', tracking.category, tracking.action, tracking.label, tracking.value, {
                        nonInteraction: tracking.nonInteraction
                    });
                } catch (e) {
                    console.log('FEHLER im EventTracking: ga() nicht gefunden. Event kann nicht an Analytics gepusht werden.');
                }

            } else if ($('#google_gtag').length) { // EventTracking mit GTAG [new]

                tracking._tools.push('gtag');
                try {
                    gtag('event', tracking.action, {
                        'event_category': tracking.category,
                        'event_label': tracking.label,
                        'value': tracking.value,
                        'non_interaction': tracking.nonInteraction
                    });
                } catch (e) {
                    console.log('FEHLER im EventTracking: gtag() nicht gefunden. Event kann nicht an GA4 gepusht werden.');
                }

            }
        }
        // }

        if (!pushOnly || pushOnly === "matomo") {
            if ($('#matomoTracking').length) {
                tracking._enable = true;
                tracking._tools.push('Matomo');
                if (transport) {
                    _paq.push(['trackEvent', tracking.category, tracking.action, tracking.label, tracking.value, { transport: transport }]);
                } else {
                    _paq.push(['trackEvent', tracking.category, tracking.action, tracking.label, tracking.value]);
                }
            }
        }

        if ((!pushOnly || pushOnly === "insider") && window.insiderOneEnabled) {

            var matchingInsiderRules = insiderTrackingRules.filter(function(rule) {
                return insiderRuleMatches(rule, tracking.category, tracking.action, tracking.label, tracking.value);
            });

            if (matchingInsiderRules.length) {
                tracking._tools.push('Insider');
            }

            matchingInsiderRules.forEach(function(rule) {

                // insiderEventName -> eventAction -> eventLabel -> eventCategory; ist auch das leer, wird für diese Regel gar nichts an Insider gepusht (weder Event noch User-Profil)
                var insiderEventName = rule.insiderEventName ||
                    slugifyInsiderEventName(tracking.action) ||
                    slugifyInsiderEventName(tracking.label) ||
                    slugifyInsiderEventName(tracking.category);

                if (!insiderEventName) {
                    console.log('FEHLER im EventTracking: kein insiderEventName ermittelbar (eventAction/eventLabel/eventCategory leer). Insider-Push wird übersprungen.');
                    return;
                }

                // pushUserData: eigenes Insider-Profil (type: 'user' + 'init') vor dem eigentlichen Event pushen, z. B. für Kontaktdaten aus einem Formular
                if (rule.pushUserData && typeof rule.buildUserData === 'function') {
                    var insiderUserData = rule.buildUserData(tracking.category, tracking.action, tracking.label, tracking.value, context);
                    if (insiderUserData && Object.keys(insiderUserData).length > 0) {
                        push2insider({ type: 'user', value: insiderUserData });
                        push2insider({ type: 'init' }); // SDK verarbeitet Benutzerdaten
                    }
                }

                // buildEventParams: eigene Custom-Event-Params (z. B. Formularfelder); ohne Angabe generischer Fallback auf category/action/label/value
                var insiderEventParams = (typeof rule.buildEventParams === 'function') ?
                    rule.buildEventParams(tracking.category, tracking.action, tracking.label, tracking.value, context) :
                    stripEmptyValues({
                        category: tracking.category,
                        action: tracking.action,
                        label: tracking.label,
                        value: tracking.value
                    });

                push2insider({
                    type: 'custom_event',
                    value: [{
                        event_name: insiderEventName,
                        event_parameters: {
                            custom: insiderEventParams
                        }
                    }]
                });

            });
        }

        if (tracking._enable) {
            console.table("%c TTG Debug ", "background: #0080a3; color: #fff", tracking);
        }
    }
}

function trackSiteSearch(response, params, type) {
    var $pagination = $($(response)[4]);

    if ($('#matomoTracking').length) {
        if (params && params.q) {
            var trackSiteSearchVars = {
                _f: 'trackSiteSearch()',
                _tools: ["Matomo"],
                q: params.q,
                category: type,
                count: 0
            };

            if ($pagination.data('items')) {
                if ($pagination.data('active') == '0') {
                    trackSiteSearchVars.count = $pagination.data('items');
                }
            }

            _paq.push(['trackSiteSearch', trackSiteSearchVars.q, trackSiteSearchVars.type, trackSiteSearchVars.count]);
            console.table("%c TTG Debug ", "background: #0080a3; color: #fff", trackSiteSearchVars);
        }
    }
}

function tosc5tracking(e, cb) {

    // Webstream: sofern die Konstante tosc5TrackingPush2DataLayer gesetzt ist, wird das Callback Objekt in das DataLayer gepusht
    if ($('#tdAppBaseUrl').length && $('#tdAppBaseUrl').data('tosc5trackingpush2datalayer') == '1') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'tosc5Tracking': {
                event: e,
                obj: cb
            }
        });
        return false;
    }

    var category = 'TOSC5 [' + e + ']',
        action = '',
        label = '',
        value = 1;

    switch (e) {
        case 'pageChange':
            break;
        case 'pageLoad':

            // category += ' [' + e + ']';

            // Siehe https://feratel.atlassian.net/wiki/spaces/FDPI/pages/62556874/Event+onPageLoad
            // console.log(e, cb);

            action = '[' + cb.pageType + ']';

            switch (cb.pageType) {

                case 100:

                    action += ' ' + cb.pageTitle; // Unterkünfte
                    label = 'Ergebnisse';
                    break;

                case 101:

                    action += ' Unterkunft';
                    label = cb.pageTitle;
                    break;

                case 102:

                    action += ' ' + cb.pageTitle; // Erlebnisse||Skitickets
                    label = 'Ergebnisse';
                    break;

                case 103:

                    action += ' Erlebnis';
                    label = cb.pageTitle;
                    break;

                case 104:

                    action += ' ' + cb.pageTitle; // Veranstaltungen
                    label = 'Ergebnisse';
                    break;

                case 105:

                    action += ' Veranstaltung';
                    label = cb.pageTitle;
                    break;

                case 106:

                    action += ' ' + cb.pageTitle; // Infrastrukturen
                    label = 'Ergebnisse';
                    break;

                case 107:

                    action += ' Infrastruktur';
                    label = cb.pageTitle;
                    break;

                case 108:

                    action += ' ' + cb.pageTitle; // Prospekte
                    label = 'Ergebnisse';
                    break;

                case 9900:

                    action += ' Warenkorb';

                    label = '[' + cb.shoppingCart.transactionType + '] Transaktionstyp';
                    // label += (cb.shoppingCart.transactionType === 1) ? ' Buchung' : ' Buchung auf Anfrage';

                    value = (cb.shoppingCart.bookingInformation.prices.totalAmount > 0) ? cb.shoppingCart.bookingInformation.prices.totalAmount : 1;
                    break;

                case 9901:

                    action += ' Buchung';
                    action += ' > [' + cb.bookingConfirmation.transactionType + '] Transaktionstyp';
                    // action += (cb.bookingConfirmation.transactionType === 1) ? ' Buchung' : ' Buchung auf Anfrage';

                    label = 'Buchungsnummer: ' + cb.bookingConfirmation.transactionNumber;
                    value = (cb.bookingConfirmation.totalAmount > 0) ? cb.bookingConfirmation.totalAmount : 1;
                    break;

                default:

                    action += ' Page Type (nicht definiert)';
                    label = cb.pageTitle;

            }

            trackEvent(category, action, label, value);

            break;

        case 'userAction':

            // console.log(e, cb);
            // category += ' [' + e + ']';

            // Siehe !https://fdcwiki.deskline.net/display/CONNECTIVITY/Event+onUserAction
            // Siehe https://feratel.atlassian.net/wiki/spaces/CONNECTIVITY/pages/62429263/DE+Event+onUserAction
            var types = [
                /*0*/
                'Klick Tel.-Nr',
                /*1*/
                'Anfrage versandt',
                /*2*/
                'Anfrage Formular geöffnet',
                /*3*/
                'Interaktion', // wird eig. immer ausgeführt, wenn was geklickt wird
                /*4*/
                'Klick Webseite',
                /*5*/
                'Warenkorb geöffnet',
                /*6*/
                'Suche/Filterung',
                /*7*/
                'Prospekt',
                /*8*/
                'Objekt > Impression',
                /*9*/
                'Objekt > Klick',
                /*10*/
                'Warenkorb > Objekt hinzufügen',
                /*11*/
                'Warenkorb > Objekt entfernen'
            ], requestTypes, searchObjectTypes, itemTypes;

            action = '[' + cb.type + ']';
            if (cb.type <= 11) {
                action += ' ' + types[cb.type];
            } else {
                action += ' Type (nicht definiert)';
            }

            switch (cb.type) {
                case 0:
                case 4:

                    label = cb.parentName;
                    break;

                case 1:
                case 2:

                    requestTypes = [
                        /*0*/
                        'Liste - Anfragepool',
                        /*1*/
                        'Liste - Persönliche Beratung',
                        /*2*/
                        'Detail - Direktanfrage (simpel)',
                        /*3*/
                        'Detail - Direktanfrage (detailliert)',
                        /*4*/
                        'Detail - Anfrage (Verfügbarkeit)'
                    ];

                    action += ' > ' + '[' + cb.requestType + ']';
                    if (cb.requestType <= 4) {
                        action += ' ' + requestTypes[cb.requestType];
                    } else {
                        action += ' RequestType (nicht definiert)';
                    }

                    label = cb.name;
                    break;

                case 5: // kein sinnvoller Wert in Callback Objekt vorhanden

                    label = "Ansicht";
                    break;

                case 6:

                    searchObjectTypes = [
                        /*0*/
                        'Erlebnis',
                        /*1*/
                        'Unterkunft'
                    ];

                    var filter = (cb.hasFilter) ? 'mit' : 'ohne';

                    label = '[' + cb.searchObjectType + ']';
                    if (cb.searchObjectType <= 1) {
                        label += ' ' + searchObjectTypes[cb.searchObjectType] + ' (' + filter + ' Filter)';
                    } else {
                        label += ' SearchObjectType (nicht definiert) (' + filter + ' Filter)';
                    }

                    value = cb.resultCount;
                    break;

                case 7:

                    var actionType = [
                        /*0*/
                        'Ansicht',
                        /*1*/
                        'Download',
                        /*2*/
                        'Bestellung'
                    ];

                    action += ' > ' + '[' + cb.actionType + ']';
                    if (cb.actionType <= 2) {
                        action += ' ' + actionType[cb.actionType];
                    } else {
                        action += ' ActionType (nicht definiert)';
                    }

                    label = cb.brochureName + ' (' + cb.language + ')';
                    break;

                case 8:

                    itemTypes = [
                        /*0*/
                        'Unterkünfte',
                        /*1*/
                        'Erlebnisse/Zusatzleistungen',
                        /*2*/
                        'Prospekte',
                        /*3*/
                        'Veranstaltungen',
                        /*4*/
                        'Infrastrukturen/POIs',
                        /*5*/
                        'Packages/Specialangebote',
                    ];

                    label = '[' + cb.itemType + ']';
                    if (cb.itemType <= 5) {
                        label += ' ' + itemTypes[cb.itemType];
                    }
                    label += ' > ' + cb.itemName + ' (' + cb.lang + ')';
                    break;

                case 9:

                    itemTypes = [
                        /*0*/
                        'Unterkünfte',
                        /*1*/
                        'Erlebnisse/Zusatzleistungen',
                        /*2*/
                        'Veranstaltungen',
                        /*3*/
                        'Infrastrukturen/POIs',
                        /*4*/
                        'Packages/Specialangebote',
                    ];

                    label = '[' + cb.itemType + ']';
                    if (cb.itemType <= 4) {
                        label += ' ' + itemTypes[cb.itemType];
                    }
                    label += ' > ' + cb.itemName + ' (' + cb.lang + ')';
                    break;

                case 10:

                    label = 'ItemId: ' + cb.item.itemId;
                    break;

                case 11:

                    label = cb.item.serviceName + ' (' + cb.item.productName + ')';
                    break;

                default:

                    label = 'nicht definiert';
                // break;

            }

            if (cb.type !== 3) { // 3 ist nicht definiert - dürfte jeglicher Klick sein
                trackEvent(category, action, label, value);
                // console.log(e, cb);
            }

            break;

    }
}

function pushDataLayer(source, obj) {

    let dataLayerObj = {
        source: source
    }, catArr = [];

    if (source === "TOURDATA") {

        dataLayerObj.event = 'tourdata_ansicht';
        if (obj.KategorienCleaned && obj.KategorienCleaned.length) {
            $.each(obj.KategorienCleaned, function(k, v) {
                catArr.push(obj.object.metaSourceCategory.toLowerCase() + '_' + v.nameCleaned);
            });
        } else {
            catArr.push(obj.object.metaSourceCategory.toLowerCase());
        }
        dataLayerObj.tourdata_unterkategorie = catArr;

    } else if (source === "TTG News" || source === "Seiten/Magazin") {

        dataLayerObj.event = 'redaktioneller_beitrag_ansicht';
        if (obj && obj.length) {
            $.each(obj, function(k, v) {
                catArr.push(v.nameCleaned);
            });
        }
        dataLayerObj.redaktionell_kategorie = catArr;

        // } else if (source === "Seiten/Magazin") {

        //     // console.log(obj);
        //     dataLayerObj.event = 'redaktioneller_beitrag_ansicht';
        //     if (obj && obj.length) {
        //         $.each(obj, function(k, v) {
        //             catArr.push(v.nameCleaned);
        //         });
        //     } else {
        //         catArr.push("");
        //     }
        //     dataLayerObj.redaktionell_kategorie = catArr;
        //     // console.log(dataLayerObj);

    }

    let doubleCatCheck = true, // ENABLE, wenn nur eine Source gepusht werden soll (PRIOS: tourdata > ttgNews > seitenMagazin)
        tourdata = false, ttgNews = false, seitenMagazin = false;

    if (doubleCatCheck && window.dataLayer) {
        $.each(window.dataLayer, function(k, v) {
            if (v.source === "TOURDATA") {
                tourdata = true;
            }
            if (v.source === "TTG News") {
                ttgNews = true;
            }
            if (v.source === "Seiten/Magazin") {
                seitenMagazin = true;
            }
        });
    }

    if (dataLayerObj.event && ((doubleCatCheck && !tourdata && !ttgNews) || !doubleCatCheck)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerObj);
        console.table("%c pushDataLayer() ", "background: #0080a3; color: #fff", dataLayerObj);
        $.each(catArr, function(k, v) {
            trackEvent('Interesse', dataLayerObj.source, v, 1);
        });
    }
}

// push2insider() wurde nach insiderQueue.js verschoben (global-head Bundle),
// da InsiderOne Page-Type Pushes bereits im <head> ausgeführt werden (OMNICHANNEL-65)

/* ==================================================================================
   SCROLL DEPTH LOGIK
   - Global 1, kann optional deaktiviert werden über die Konstante scrollDepth = 0
   ================================================================================== */

// Scroll-Event senden (nur 1x pro Seite)
function sendMaxScrollDepth() {
    if (scrollDepthSent) return; // Verhindert Mehrfachsenden
    // Value: 0.25 / 0.5 / 0.75 / 1 für 25% / 50% / 75% / 100%
    var value = maxScrollDepth / 100;
    var label = maxScrollDepth + "%";
    if (maxScrollDepth > 0) {
        trackEvent("Scroll Depth", "Maximum", label, value, (maxScrollDepth > 50) ? false : true, "matomo");
        /* NonInteraction beeinflusst die BounceRate > wenn mehr als 50% gescrollt wurde, dann werten wir den User nicht mehr als Bounce >> nonInteraction=false */
        scrollDepthSent = true;
    }
}

if ($('body').data('scrollDepth')) {

    // Trigger: pagehide (sicherster Trigger für "Seite wird verlassen" inkl. SPA & Mobile)
    window.addEventListener('pagehide', sendMaxScrollDepth);
    // Fallback: visibilitychange (für Kompatibilität mit alten Browsern)
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
            sendMaxScrollDepth();
        }
    });

}

/* ==================================================================================
   TTG SESSION SCORE LOGIK
   - Global 0, kann optional aktiviert werden über die Konstante sessionScoring = 1
   - DeltaScore (bei jeder Änderung)
   ================================================================================== */

if ($('body').data('sessionScoring')) {

    (function() {

        /* ===============================
           1. KONFIGURATION
        =============================== */

        var CONFIG = {
            cookieName: "_ttg_sess_score",
            tracking: {
                category: "Engagement",
                actionDelta: "SessionScore | update"
            },
            matrix: {
                scroll: {
                    step1: { threshold: 25, points: 0.25 },
                    step2: { threshold: 50, points: 0.25 },
                    step3: { threshold: 75, points: 0.25 },
                    step4: { threshold: 99, points: 0.25 },
                    maxScrollScore: 1.0
                },
                pages: {
                    level1: { count: 2, points: 0.5 },
                    level2: { count: 3, points: 0.5 },
                    level3: { count: 5, points: 0.5 }
                },
                time: {
                    level1: { seconds: 120, points: 0.5 },
                    level2: { seconds: 300, points: 0.5 }
                },
                maxTotalScore: 3.5
            }
        };

        /* ===============================
           2. COOKIE HELPERS
        =============================== */

        function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? JSON.parse(decodeURIComponent(v[2])) : null;
        }

        function setCookie(name, value) {
            // Session läuft nach 30 Minuten Inaktivität ab
            document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + "; path=/; SameSite=Lax; Max-Age=1800";
        }

        /* ===============================
           4. INITIALISIERUNG
        =============================== */

        var data = getCookie(CONFIG.cookieName);
        var currentPath = window.location.pathname;

        if (!data || typeof data.st === 'undefined') {

            console.log("%c[SessionScore] Neue anonyme Session gestartet.", "color: #008000; font-weight: bold;");

            data = {
                scrollTotal: 0,
                currPageS: { s25: 0, s50: 0, s75: 0, s100: 0 },
                pc: 0,
                lp: "",
                st: Date.now(),
                logs: { p1: 0, p2: 0, p3: 0, t1: 0, t2: 0 }
            };

        } else {

            var bd = getBreakdown(data);
            console.log(
                "%c[SessionScore] Laufende Session\n",
                "color:#008000;",
                "Score: " + bd.total +
                " (Scroll: " + bd.scroll + " [" + getCookie(CONFIG.cookieName).scrollTotal + "]" +
                " | Pages: " + bd.pages +
                " | Time: " + bd.time + ")"
            );
        }

        /* ===============================
           5. SCORE BERECHNUNG
        =============================== */

        function getBreakdown(d) {
            if (!d) d = getCookie(CONFIG.cookieName);
            if (!d) return { scroll: 0, pages: 0, time: 0, total: 0 };

            var m = CONFIG.matrix;

            var cappedScroll = Math.min(d.scrollTotal, m.scroll.maxScrollScore);

            var pageScore = 0;
            if (d.pc >= m.pages.level1.count) pageScore += m.pages.level1.points;
            if (d.pc >= m.pages.level2.count) pageScore += m.pages.level2.points;
            if (d.pc >= m.pages.level3.count) pageScore += m.pages.level3.points;

            var timeScore = 0;
            var seconds = (Date.now() - d.st) / 1000;
            if (seconds >= m.time.level1.seconds) timeScore += m.time.level1.points;
            if (seconds >= m.time.level2.seconds) timeScore += m.time.level2.points;

            var total = Math.min(cappedScroll + pageScore + timeScore, m.maxTotalScore);

            return { scroll: cappedScroll, pages: pageScore, time: timeScore, total: total };
        }

        function calculateScore() {
            return getBreakdown().total;
        }

        /* ===============================
           6. DELTA PUSH
        =============================== */

        function pushDelta(deltaValue, reason) {
            if (!deltaValue || deltaValue <= 0) return;

            // Nur pushen, wenn Gesamt-Score noch im Cap ist
            var currentScore = calculateScore();
            if (currentScore > CONFIG.matrix.maxTotalScore) return;

            if (typeof trackEvent === "function") {
                trackEvent(
                    CONFIG.tracking.category,
                    CONFIG.tracking.actionDelta,
                    reason,
                    deltaValue,
                    true,
                    false
                );
            }
        }

        /* ===============================
           7. LOG HELPER
        =============================== */

        function logUpdate(triggerName, addedPoints) {
            var bd = getBreakdown();
            console.log(
                "%c[SessionScore] " + triggerName + "\n",
                "color:#cabd00;",
                "+" + addedPoints +
                " (Scroll: " + bd.scroll + " [" + getCookie(CONFIG.cookieName).scrollTotal + "]" +
                " | Pages: " + bd.pages +
                " | Time: " + bd.time +
                " | TOTAL: " + bd.total + ")"
            );
        }

        /* ===============================
           8. SEITENWECHSEL
        =============================== */

        if (data.lp !== currentPath) {

            data.pc = (data.pc || 0) + 1;
            data.lp = currentPath;
            data.currPageS = { s25: 0, s50: 0, s75: 0, s100: 0 };

            setCookie(CONFIG.cookieName, data);

            var m = CONFIG.matrix;
            var points = 0;
            var label = "";
            var triggered = false;

            if (data.pc === m.pages.level1.count && !data.logs.p1) {
                data.logs.p1 = 1;
                points = m.pages.level1.points;
                label = "Seite " + data.pc;
                triggered = true;
            }
            else if (data.pc === m.pages.level2.count && !data.logs.p2) {
                data.logs.p2 = 1;
                points = m.pages.level2.points;
                label = "Seite " + data.pc;
                triggered = true;
            }
            else if (data.pc === m.pages.level3.count && !data.logs.p3) {
                data.logs.p3 = 1;
                points = m.pages.level3.points;
                label = "Seite " + data.pc;
                triggered = true;
            }

            if (triggered) {
                setCookie(CONFIG.cookieName, data);
                logUpdate(label, points);
                pushDelta(points, label);
            }
        }

        /* ===============================
           9. SCROLL
        =============================== */

        function updateScroll() {

            var d = getCookie(CONFIG.cookieName);
            if (!d) return;

            var doc = document.documentElement;
            var percent = (doc.scrollTop / (doc.scrollHeight - doc.clientHeight)) * 100;

            var s = CONFIG.matrix.scroll;
            var points = 0;
            var label = "";
            var changed = false;

            if (percent >= s.step1.threshold && !d.currPageS.s25) {
                d.currPageS.s25 = 1;
                d.scrollTotal += s.step1.points;
                points = s.step1.points;
                label = "Scroll 25%";
                changed = true;
            }
            else if (percent >= s.step2.threshold && !d.currPageS.s50) {
                d.currPageS.s50 = 1;
                d.scrollTotal += s.step2.points;
                points = s.step2.points;
                label = "Scroll 50%";
                changed = true;
            }
            else if (percent >= s.step3.threshold && !d.currPageS.s75) {
                d.currPageS.s75 = 1;
                d.scrollTotal += s.step3.points;
                points = s.step3.points;
                label = "Scroll 75%";
                changed = true;
            }
            else if (percent >= s.step4.threshold && !d.currPageS.s100) {
                d.currPageS.s100 = 1;
                d.scrollTotal += s.step4.points;
                points = s.step4.points;
                label = "Scroll 100%";
                changed = true;
            }

            if (changed) {
                setCookie(CONFIG.cookieName, d);

                // Nur pushDelta, wenn maxScrollScore noch nicht überschritten wurde
                if (d.scrollTotal <= CONFIG.matrix.scroll.maxScrollScore) {
                    logUpdate(label, points);
                    pushDelta(points, label);
                }
            }
        }

        /* ===============================
           10. ZEIT
        =============================== */

        function checkTimeLogs() {

            var d = getCookie(CONFIG.cookieName);
            if (!d) return;

            var seconds = (Date.now() - d.st) / 1000;
            var m = CONFIG.matrix;
            var points = 0;
            var label = "";
            var changed = false;

            if (seconds >= m.time.level1.seconds && !d.logs.t1) {
                d.logs.t1 = 1;
                points = m.time.level1.points;
                label = "Zeit 120s";
                changed = true;
            }
            else if (seconds >= m.time.level2.seconds && !d.logs.t2) {
                d.logs.t2 = 1;
                points = m.time.level2.points;
                label = "Zeit 300s";
                changed = true;
            }

            if (changed) {
                setCookie(CONFIG.cookieName, d);
                logUpdate(label, points);
                pushDelta(points, label);
            }
        }

        /* ===============================
           11. EVENTS
        =============================== */

        var ticking = false;

        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    updateScroll();
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });

        setInterval(function() {
            checkTimeLogs();

            // Cookie-Heartbeat: Cookie aktualisieren, um Session am Leben zu erhalten
            // solange die Seite sichtbar ist (verhindert Session-Abbruch bei langen Verweildauern)
            var d = getCookie(CONFIG.cookieName);
            if (d && document.visibilityState === 'visible') {
                setCookie(CONFIG.cookieName, d);
            }
        }, 5000);

    })();
}
/* ==================================================================================
   TTG SESSION SCORE LOGIK ENDE
   ================================================================================== */
